import { Alert } from "antd";
import type { AlertProps } from "antd";

export type UIAlertProps = AlertProps;

export const UIAlert = (props: UIAlertProps) => <Alert {...props} />;
